import api from "./api";

// MELHORIA 13 — cards a cobrar do atendimento logado.
export interface CobrancaPendente {
  id: string;
  titulo: string;
  status: string;
  colunaLabel: string;
  colunaEmoji: string;
  colunaCor: string | null;
  projetoId: string | null;
  projetoNome: string | null;
  cliente: string | null;
  statusDesde: string | null;
  paradoMs: number;
  ultimaCobrancaEm: string | null;
  precisaCobrarHoje: boolean;
  slaEstourado: boolean;
}

export async function listarCobrancaPendentes() {
  const r = await api.get("/tarefas/cobranca-pendentes");
  return r.data.data as CobrancaPendente[];
}

export async function registrarCobranca(tarefaId: string) {
  const r = await api.post(`/tarefas/${tarefaId}/cobranca-cliente`);
  return r.data.data;
}
